import { theme } from 'antd'

export default {
  token: {
    colorPrimary: '#004FF8',
    fontSize: 14,
    colorText: '#111111',
    borderRadius: 4,
    wireframe: false,
  },
  algorithm: theme.defaultAlgorithm,
  components: {
    Slider: {
      dotActiveBorderColor: '#1E86FF',
      handleColor: '#1E86FF',
      trackBg: '#1E86FF',
      trackHoverBg: '#004FF8',
      /* here is your component tokens */
    },
  },
  // components: {
  //   Radio: {
  //     colorPrimary: '#00b96b'
  //   }
  // }
}
